var React = require('react');

function ChevronDownBInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("g",{"id":"small/navigation/mobile-triage-menu-selected","transform":"translate(-71.000000, -20.000000)","stroke":"#015294","strokeWidth":"2"},React.createElement("polyline",{"id":"Path-2","transform":"translate(75.375000, 22.500000) rotate(90.000000) translate(-75.375000, -22.500000) ","points":"73.875 19.125 76.875 22.5 73.875 25.875"}))));
}

ChevronDownBInline.defaultProps = {"width":"9px","height":"6px","viewBox":"0 0 9 6","version":"1.1"};

module.exports = ChevronDownBInline;

ChevronDownBInline.default = ChevronDownBInline;
